import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function PageHeader({ icon, title, subtitle, onRefresh, refreshing, action }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        mb: 3,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 3,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ color: "primary.main", display: "flex" }}>{icon}</Box>
            <Typography variant="h5" sx={{ fontWeight: 800 }}>{title}</Typography>
          </Stack>
          {subtitle && <Typography color="text.secondary" sx={{ mt: 0.6 }}>{subtitle}</Typography>}
        </Box>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
          {action}
          {onRefresh && (
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh} disabled={refreshing}>
              Refresh
            </Button>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
}
